import logFactory, { LogLevels } from 'c9-js-log-client';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ActiveUser, ConfigObject } from 'top-context';
import App from './App';
import AvailabilitiesContext from './contexts/AvailabilitiesContext';
import ResourceContext from './contexts/ResourceContext';
import { store } from './store';
import { settingsActions } from './store/settings.slice';
import { userActions } from './store/user.slice';
import { AppConfig } from './types';
import log, { registerLogger } from './utils/logger';

type LogLevel = (typeof LogLevels)[keyof typeof LogLevels];

let context = window || {};

context.ScheduleACallback = (function () {
  function boostrapApplication(
    config: ConfigObject & AppConfig,
    user: ActiveUser,
    boostrapElement: HTMLElement,
    logLevel = ''
  ) {
    if (!AppConfig.guard(config)) {
      // if configuration is not valid, do not load the app.
      console.error('Invalid configuration: ', config);
      throw new Error(`Exiting due to application configuration error.`);
    }

    const level = (isLogLevel(logLevel) ? logLevel : config.getSiteConfig().logLevel) as LogLevel;
    const logger = logFactory(config.getEndpointConfig().logger, config.appName, level);
    registerLogger(logger);
    log.debug(`Starting up application ${logger.appName}`);

    store.dispatch(
      settingsActions.setSettings({
        appName: config.appName,
        endpointConfig: config.getEndpointConfig(),
        siteConfig: config.getSiteConfig(),
        activeModules: config.activeModules,
      })
    );

    store.dispatch(userActions.setActiveUser(user));

    ReactDOM.render(
      <Provider store={store}>
        <ResourceContext>
          <AvailabilitiesContext>
            <App />
          </AvailabilitiesContext>
        </ResourceContext>
      </Provider>,
      boostrapElement
    );
  }

  return boostrapApplication;
})();

function isLogLevel(value: string): value is LogLevel {
  return Object.keys(LogLevels).includes(value);
}
